@if (openChangeScore || openQuestionDetails || openPartChangeScore || openConfirmDeleteExamPart) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full flex justify-center items-center">
      <div class="items-center justify-center rounded-[16px] bg-white p-3 absolute w-[400px]">
        @if (openChangeScore) {
          <div>
            <div class="mb-2 font-bold text-center">
              Update Correctness
            </div>
            <div class="text-sm text-center">
              Enter number in the range of 0.0 and 1.0 for question correctness.
            </div>
            <input type="number" placeholder="Enter correctness" class="input mt-2 w-full" [(ngModel)]="newCorrectness"/>
            <div class="flex justify-between mt-5">
              <outline-button [marginRight]="true" (click)="cancelChangeScore()" text="Cancel" />
              <full-button (click)="saveChangeScore()" text="Save" />
            </div>
          </div>
        }
        @if (openPartChangeScore) {
          <div>
            <div class="mb-2 font-bold text-center">
              Update Total Part Score
            </div>
            <div class="text-sm text-center">
              Enter new total part score
            </div>
            <input type="number" placeholder="Enter new score" class="input mt-2 w-full" [(ngModel)]="newPartScore"/>
            <div class="flex justify-between mt-5">
              <outline-button [marginRight]="true" (click)="cancelChangePartScore()" text="Cancel" />
              <full-button (click)="saveChangePartScore()" text="Save" />
            </div>
          </div>
        }
        @if (openConfirmDeleteExamPart) {
          <div>
            <div class="mb-2 font-bold text-center">
              Are you sure you want to delete this exam part instance?
            </div>
            <div class="flex justify-between mt-5">
              <outline-button [marginRight]="true" (click)="openConfirmDeleteExamPart = false" text="Cancel" />
              <full-button (click)="confirmDeleteExamPart()" text="Delete" />
            </div>
          </div>
        }
        @if (openQuestionDetails && questionToBeDetailed != null) {
          <div>
            <div class="flex items-center justify-between">
              <b>Question Details</b>
              <button aria-label="Close Question Details" (click)="openQuestionDetails = false" class="rounded-full text-xs h-[25px] w-[25px] p-1 hover:bg-gray-200">
                <fa-icon [icon]="faX" />
              </button>
            </div>
            <hr class="-mx-3 my-2" />
            <div class="mt-2">
              <div>
                <b>Question:</b>
              </div>
              <div>
                {{questionToBeDetailed.question.question_text}}
              </div>
            </div>
            @if (questionToBeDetailed.question.recordedAnswer != null) {
              <div class="mt-2">
                <div class="mt-4">
                  <b>Recorded Answer:</b>
                </div>
                <div [innerHTML]="questionToBeDetailed.question.recordedAnswer.replace('\n', '<br/>')">
              </div>
            </div>
          }
          @if (questionToBeDetailed.question.recordedAnswer == null) {
            <div class="mt-2">
              <b>No Recorded Answer</b>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
}
@if (!isStudent) {
  <breadcrumb endText="Exam Instance Review" [navigations]="breadcrumbNav" />
}
<div class="m-6 pb-5">
  @if (submissionReview != null) {
    <div class="text-xl font-bold mb-6">
      {{studentName}}: {{username}} submission for {{submissionReview.details.exam_title}}
    </div>
  }
  @for (part of submissionReview?.parts; let i = $index; track part) {
    <div class="mt-3">
    <div [ngClass]="part.isExpanded?
    'mt-2 justify-between rounded-t-[8px] flex p-2 items-center w-full border-[#74808B] border-t border-r border-l text-lg':
    'mt-2 rounded-[8px] flex justify-between p-2 items-center w-full border border-[#74808B] text-lg'"  (click)="togglePartExpansion(part)">
        <button aria-label="Toggle Expand" (click)="part.isExpanded = !part.isExpanded" class="hover:bg-gray-200 px-2 py-1 rounded-[4px]">
          @if (!part.isExpanded) {
            <fa-icon [icon]="faChevronUp" class="mr-2 text-xs" />
          }
          @if (part.isExpanded) {
            <fa-icon [icon]="faChevronDown" class="mr-2 text-xs" />
          }
          {{part.details.part_name}}
        </button>
        <!-- TODO click action to open change part score dialog -->
        <div class="flex gap-1 items-center mr-5">
          <button aria-label="Open Change Part Score Dialog" [disabled]="isStudent || !examAdmin" (click)="openChangePartDialog(part.part_position)" [ngClass]="isStudent || !examAdmin? 'grid grid-cols-2 px-2 py-1 rounded-[4px]':  'grid-cols-2 px-2 py-1 hover:bg-gray-200 rounded-[4px]'">
            <b class="mr-1">Part Score: </b>
            <span class="flex">
            @if (part.part_score_override == null) {
              <p>
                {{part.part_score != null? part.part_score: 'no score'}}
              </p>
            }
              @if (part.part_score_override != null) {
                <p>
                {{part.part_score_override}}
              </p>
              }
              /{{part.available_score}}
              @if (!isStudent && examAdmin) {
                <fa-icon [icon]="faPenToSquare" class="text-sm ml-1" />
              }
          </span>
          </button>
          <div>
            <button aria-label="Delete exam part" tooltip="Delete Exam Part"
                    (click)="openConfirmDeleteExamPart = true; deletePartID = part.exampartinstance_id; deletePartIndex = i;"
                    [ngClass]="isStudent || !examAdmin?
                  'p-2 rounded-full flex items-center justify-center':
                  'hover:bg-[#FBEBEF] p-2 rounded-full flex items-center justify-center'">
              <fa-icon [icon]="faTrash" class="text-sm text-[#CC0033]" />
            </button>
          </div>
        </div>
      </div>
      @if (part.isExpanded) {
        <div class="border-[#74808B] border-l border-r border-b rounded-b-[8px]">
          @for (question of part.questions; track question; let i = $index) {
            <div class="p-2 grid grid-cols-4">
              <div class="col-span-3">
                <p><b>Question #{{i+1}}</b></p>
                <div class="rounded-[8px] border-[#74808B] border p-3 m-3">
                  <div>
                    <b>Question:</b>
                  </div>
                  @if (checkForHTMLTags(question.question.question_text)) {
                    <div [innerHTML]="question.question.question_text"></div>
                  }
                  @if (!checkForHTMLTags(question.question.question_text)) {
                    <div>
                      {{question.question.question_text}}
                    </div>
                  }
                  <div>
                    <b>Recorded Answer:</b>
                  </div>
                  @if (question.question.type === 'MULTIPLECHOICE') {
                    <div>
                      <multiple-choice [review]="true" [problem_template]="question.question" [(recordedAnswer)]="question.question.recordedAnswer"/>
                    </div>
                  }
                  @if (question.question.type === 'DECIMAL' || question.question.type === 'INTEGER') {
                    <div>
                      <decimal [review]="true" [(answer)]="question.question.recordedAnswer" />
                    </div>
                  }
                  @if (question.question.type === 'TEXTAREA' || question.question.type === 'REGEX') {
                    <div>
                      <text-area [review]="true"  [(answer)]="question.question.recordedAnswer" />
                    </div>
                  }
                  @if (question.question.type === 'MULTIFIELD' || question.question.type === 'PASSAGE') {
                    <div>
                      <multifield [review]="true"  [problem_template]="question.question" [(answer)]="question.question.recordedAnswer"/>
                    </div>
                  }
                  @if (question.question.type === 'FORMULA') {
                    <div>
                      <formula />
                    </div>
                  }
                  @if (question.question.type === 'PROGRAMMING') {
                    <div>
                      <code-editor
                        [(code)]="question.question.recordedAnswer"
                        [recordedAnswer]="question.question.recordedAnswer"
                        [answerSkeleton]="question.question.answerSkeleton"
                        [review]="true"
                        />
                      </div>
                    }
                    @if (question.question.type === 'RECORD_AUDIO' && question.question.recordedAnswer) {
                      <div>
                        <audio-playback [audio_url]="question.question.recordedAnswer"></audio-playback>
                      </div>
                    }
                    @if (question.question.type === 'GROUPING' && question.question.recordedAnswer !== null) {
                      <div class="mt-2">
                        <grouping [viewOnly]="true" [problem_template]="question.question" [answer]="question.question.recordedAnswer"/>
                      </div>
                    }
                    @if (question.question.type === 'UPLOAD_DOC' && question.question.recordedAnswer !== null) {
                      <div class="mt-2">
                        <a [href]="question.question.recordedAnswer" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">
                          View Uploaded File
                        </a>
                      </div>
                    }
                  </div>
                </div>
                <div>
                  <p><b>Score</b></p>
                  <div class="mr-3 flex h-full items-start">
                    <button [disabled]="isStudent || !examAdmin" (click)="changeScore(question.question_position, part.part_position)" [ngClass]="isStudent || !examAdmin? 'rounded-[4px] p-1.5': 'rounded-[4px] hover:bg-gray-200 p-1.5'">
                      {{question.points_earned != null? question.points_earned: 'no score'}}
                      @if (!isStudent && examAdmin) {
                        <fa-icon [icon]="faPenToSquare" class="text-sm ml-1" />
                      }
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
